module.exports = __webpack_public_path__ + "media/images/vp/icon.burgerdots.red-89c1dee42c1ee957e30d229f1a1d2df7.svg";